import { checkIfAppleDevice, checkIfIOS } from "../lib/frontend-helpers"
import { Fragment } from "react"
import { Popover, Transition } from "@headlessui/react"
import { useAppContext } from "../context/state"
import { useLocomotiveScroll } from "react-locomotive-scroll"
import { useRef, useEffect, useState } from "react"
import { useTheme } from "next-themes"
import lAudioToggle from "../public/l-audio-toggle.json"
import lottie from "lottie-web"

let isStatic = true
let isHidden = false

export const iconTwitter = (
  <svg
    className="w-[1.5vmax]"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2.01254C19.435 2.88347 18.757 3.62131 17.9659 4.22607C17.9659 4.28491 17.973 4.37726 17.9873 4.5031C18.0016 4.62894 18.0088 4.72128 18.0088 4.78013C18.0088 5.93125 17.8463 7.08237 17.5214 8.2335C17.1964 9.38462 16.7021 10.4841 16.0383 11.5321C15.3746 12.58 14.5872 13.5097 13.676 14.3214C12.7649 15.133 11.6703 15.7823 10.3922 16.2694C9.11411 16.7565 7.74048 17 6.27132 17C3.98289 17 1.89245 16.3581 0 15.0744C0.395559 15.1038 0.720498 15.1185 0.974817 15.1185C2.88156 15.1185 4.58359 14.5135 6.08091 13.3036C5.19101 13.2886 4.39643 13.0046 3.69716 12.4514C2.99789 11.8983 2.50701 11.1862 2.22453 10.3153C2.46455 10.3741 2.72581 10.4036 3.00829 10.4036C3.38955 10.4036 3.7498 10.3445 4.08903 10.2263C3.14281 10.0199 2.35884 9.52562 1.73712 8.74342C1.11541 7.96122 0.804549 7.0611 0.804549 6.04306V5.99892C1.34135 6.29406 1.9557 6.45634 2.6476 6.48576C2.09694 6.1019 1.65914 5.5965 1.3342 4.96957C1.00926 4.34263 0.846791 3.66748 0.846791 2.94412C0.846791 2.20628 1.02334 1.48315 1.37644 0.774733C2.40758 2.11779 3.65405 3.17657 5.11584 3.95107C6.57763 4.72558 8.16312 5.15719 9.8723 5.24592C9.77352 4.877 9.72413 4.55244 9.72413 4.27224C9.72413 3.09169 10.1266 2.08452 10.9316 1.25071C11.7366 0.416903 12.7183 0 13.8768 0C14.4418 0 14.9855 0.118145 15.508 0.354435C16.0305 0.590726 16.4755 0.922754 16.8429 1.35052C17.7752 1.15859 18.6439 0.811852 19.4489 0.310301C19.1521 1.31386 18.5519 2.1033 17.6481 2.67864C18.5098 2.56049 19.2938 2.33914 20 2.01458V2.01254Z"
      fill="#FCFAF7"
    />
  </svg>
)

const solutions = [
  {
    name: "Magic Marketplace",
    description: "Holder access features",
    route: "marketplace",
    icon: iMarketplace,
  },
  {
    name: "Equip Items",
    description: "Acquire & Equip",
    route: "pets",
    icon: iEquip,
  },
  {
    name: "Quest Map",
    description: "See the journey",
    route: "quest-map",
    icon: iQuestMap,
  },
  {
    name: "Advisors/Team",
    description: "Wise and trusted",
    route: "advisors",
    icon: iTeam,
  },
  {
    name: "FAQs",
    description: "Your Questions: Granted",
    route: "faqs",
    icon: iFaqs,
  },
]

let audioDirection = 1
let isPlayingAudio = false
let audioToggleAnimation = null

const Header = (props) => {
  const { router, skippedFactions } = props
  const { scroll } = useLocomotiveScroll()
  const headerRef = useRef()
  const globalState = useAppContext()
  const { setAudioLoadedCount } = globalState

  const { theme } = useTheme()
  const SSR = typeof window === "undefined"
  const [isAppleDevice, setIsAppleDevice] = useState(false)
  const [isIOS, setIsIOS] = useState(false)

  const setThemes = () => {
    const newOppositeTheme = theme === "dark" ? "light" : "dark"

    if (isPlayingAudio === true) {
      try {        
        document.queryselector(`#audio-${newOppositeTheme}`).pause()
        document.querySelector(`#audio-${theme}`).play()
      } catch (error) {
        // console.log(error)
      }
    }
  }
  useEffect(() => {
    if (theme) setThemes()
  }, [theme])
  useEffect(() => {
    if (SSR) return
    setThemes()
    setIsAppleDevice(checkIfAppleDevice(window))
    setIsIOS(checkIfIOS(window))
  }, [])

  useEffect(() => {
    if (globalState.factionChosen === false) return
    if (isPlayingAudio === false && isAppleDevice === false && isIOS === false && skippedFactions === false) toggleAudio(theme)
  }, [globalState.factionChosen])

  useEffect(() => {
    if (scroll === null) return

    scroll.on("scroll", (instance) => {
      const header = headerRef?.current
      if (!header) return

      let headerHeight = header.getBoundingClientRect().height
      if (instance.direction === "down" && isStatic) {
        if (instance.scroll.y > headerHeight) {
          // console.log('header - static - pinned')
          header.classList.add("pinned", "no-bg-yet")
          isStatic = false
        }
      }
      if (instance.direction === "up" && !isStatic) {
        if (instance.scroll.y <= headerHeight) {
          // console.log('header - static - unpinned')
          header.classList.remove("pinned")
          isStatic = true
        }
      }
      if (instance.direction === "down" && !isHidden) {
        if (instance.scroll.y > headerHeight + 200) {
          // console.log('header - hidden - unpinned')
          header.classList.remove("pinned", "no-bg-yet")
          header.classList.add("unpinned")
          isHidden = true
        }
      }
      if (instance.direction === "up" && isHidden) {
        // console.log('header - hidden - pinned')
        header.classList.remove("unpinned", "no-bg-yet")
        header.classList.add("pinned")
        isHidden = false
      }
    })
  }, [scroll])

  const toggleAudio = async (currentTheme) => {
    await new Promise((r) => setTimeout(r, 200))

    try {
      isPlayingAudio = isPlayingAudio === false ? true : false
      audioDirection = audioDirection === -1 ? 1 : -1
      const currentAudio = document.querySelector(`#audio-${currentTheme}`)
  
      if (isPlayingAudio === true) {
        currentAudio.play()
      } else {
        currentAudio.pause()
      }
  
      if (audioToggleAnimation !== null) {
        audioToggleAnimation.setDirection(audioDirection)
        audioToggleAnimation.play()
      }
    } catch (error) {
      // console.log(error)
    }
  }

  const goToQuestMap = () => {
    scroll.scroll.scrollTo(`#scene-quest-map`, {
      // offset: -100,
      duration: 10,
    })
    router.push("/home/quest-map", undefined, { shallow: true })
  }

  const goTo = (id) => {
    scroll.scroll.scrollTo(`#scene-${id}`)
    router.push(`/home/${id}`, undefined, { shallow: true })
  }

  const goToFooter = () => {
    scroll.scroll.scrollTo(`#scene-footer`)
  }

  useEffect(() => {
    if (SSR) return

    const audioToggle = document.getElementById("audio-toggle")

    // fix hot reload causing multiple instances
    if (audioToggle.childNodes.length === 0) {
      audioToggleAnimation = lottie.loadAnimation({
        container: audioToggle,
                loop: false,
        autoplay: false,
        animationData: lAudioToggle,
      })
    }

    if (isPlayingAudio === false && audioToggleAnimation !== null) audioToggleAnimation.goToAndStop(28, true)
  }, [SSR])

  return (
    <header
      className="nav-header fixed left-0 top-0 z-[9000] w-full px-1 md:px-5 md:py-5"
      ref={headerRef}
    >
      <div className="nav-bg absolute left-0 top-0 z-[1] h-full w-full opacity-0" />
      <nav className="relative z-[2] grid grid-cols-3 items-center self-center py-2 3xl:mx-auto">
        <div className="flex w-full items-center justify-start">
          <a className="ml-[1vmax] block w-[14vmax]" href="/">
            <span className="hidden">Magic Folk</span>
            {iLogo()}
          </a>
        </div>

        <div />

        <ul className="flex items-center justify-end">
          <li className="invisible md:visible">
            <button onClick={goToQuestMap} className="mr-[1vmax] block">
              <span className="hidden">Quest Map</span>
              <svg
                className="w-[9.6vmax]"
                width="148"
                height="48"
                viewBox="0 0 148 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 24C0 10.7452 10.7452 0 24 0H124C137.255 0 148 10.7452 148 24V24C148 37.2548 137.255 48 124 48H24C10.7452 48 0 37.2548 0 24V24Z"
                  fill="#1D1A25"
                />
                <path
                  d="M41.6674 27.516L40.2394 26.942C40.7434 26.13 41.0374 25.164 41.0374 24.1C41.0374 21.146 38.8254 18.962 35.8574 18.962C32.8894 18.962 30.6774 21.146 30.6774 24.1C30.6774 27.054 32.8894 29.238 35.8574 29.238C36.6554 29.238 37.3834 29.084 38.0414 28.804L40.5054 29.938L41.6674 27.516ZM35.8574 26.508C34.6114 26.508 33.6174 25.514 33.6174 24.1C33.6174 22.686 34.6114 21.692 35.8574 21.692C37.1034 21.692 38.0974 22.686 38.0974 24.1C38.0974 25.514 37.1034 26.508 35.8574 26.508ZM48.761 24.646C48.761 25.794 48.257 26.508 47.193 26.508C46.129 26.508 45.625 25.794 45.625 24.646V19.2H42.783V25.024C42.783 27.628 44.575 29.238 47.193 29.238C49.811 29.238 51.603 27.628 51.603 25.024V19.2H48.761V24.646ZM53.6292 29H60.9512V26.48H56.4292V25.318H59.4112V22.826H56.4292V21.72H60.9512V19.2H53.6292V29ZM66.3575 29.238C68.5555 29.238 70.3055 28.09 70.3055 26.186C70.3055 24.618 69.5775 23.61 67.9115 23.134L66.1895 22.644C65.6015 22.476 65.3635 22.28 65.3635 21.944C65.3635 21.622 65.6575 21.314 66.3015 21.314C66.9875 21.314 67.3795 21.762 67.5755 22.364L70.1235 21.412C69.5915 19.928 68.3455 18.962 66.2455 18.962C64.0335 18.962 62.4795 20.348 62.4795 22.084C62.4795 23.54 63.4035 24.646 64.9435 25.108L66.7355 25.64C67.2115 25.78 67.4075 26.004 67.4075 26.298C67.4075 26.592 67.1135 26.9 66.4135 26.9C65.5175 26.9 64.9995 26.312 64.7615 25.654L62.2135 26.606C62.7175 28.272 64.2855 29.238 66.3575 29.238ZM73.7567 29H76.6127V21.86H79.2167V19.2H71.1527V21.86H73.7567V29ZM84.8125 29H87.3605L87.3465 24.492C87.3465 23.596 87.2485 22.238 87.2485 22.238H87.2765C87.2765 22.238 87.6685 23.582 87.9625 24.492L89.3905 29H91.6865L93.1005 24.492L93.7865 22.238H93.8145C93.8145 22.238 93.7165 23.596 93.7165 24.492V29H96.2645V19.2H92.3025L91.1125 23.022C90.7625 24.142 90.5525 25.234 90.5525 25.234H90.5245C90.5245 25.234 90.3145 24.142 89.9645 23.022L88.7745 19.2H84.8125V29ZM105.056 29H107.968L104.524 19.2H100.912L97.4678 29H100.38L100.982 27.138H104.454L105.056 29ZM101.654 25.038L102.116 23.582C102.41 22.658 102.704 21.538 102.704 21.538H102.732C102.732 21.538 102.998 22.658 103.292 23.582L103.768 25.038H101.654ZM113.963 19.2H109.161V29H111.989V26.004H113.949C115.769 26.004 117.463 24.828 117.463 22.602C117.463 20.264 115.811 19.2 113.963 19.2ZM113.403 23.68H111.989V21.58H113.445C114.159 21.58 114.607 21.902 114.607 22.602C114.607 23.33 114.145 23.68 113.403 23.68Z"
                  fill="#FEFCF9"
                />
              </svg>
            </button>
          </li>
          <li>
            <Popover className="relative -top-[2px] md:top-0">
              {({ open }) => (
                <>
                  <Popover.Button
                    className={`
                      ${open ? "" : "text-opacity-90"}
                      group mr-2 inline-flex h-[2.7vmax] items-center justify-center rounded-3xl border-[0.16vmax] border-white px-2 font-sans font-bold uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 md:mr-4 md:px-6`}
                  >
                    <span className="hidden">Jump To</span>
                    <svg
                      className="h-[6px] md:h-[10px]"
                      viewBox="0 0 65 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.09802 11.168C3.65202 11.168 5.37402 10.342 5.37402 8.032V1.2H2.51802V7.472C2.51802 8.298 2.09802 8.522 1.46802 8.522C1.03402 8.522 0.642015 8.438 0.306015 8.312V10.79C0.838015 11.028 1.46802 11.168 2.09802 11.168ZM13.2419 6.646C13.2419 7.794 12.7379 8.508 11.6739 8.508C10.6099 8.508 10.1059 7.794 10.1059 6.646V1.2H7.26391V7.024C7.26391 9.628 9.05591 11.238 11.6739 11.238C14.2919 11.238 16.0839 9.628 16.0839 7.024V1.2H13.2419V6.646ZM18.1101 11H20.6581L20.6441 6.492C20.6441 5.596 20.5461 4.238 20.5461 4.238H20.5741C20.5741 4.238 20.9661 5.582 21.2601 6.492L22.6881 11H24.9841L26.3981 6.492L27.0841 4.238H27.1121C27.1121 4.238 27.0141 5.596 27.0141 6.492V11H29.5621V1.2H25.6001L24.4101 5.022C24.0601 6.142 23.8501 7.234 23.8501 7.234H23.8221C23.8221 7.234 23.6121 6.142 23.2621 5.022L22.0721 1.2H18.1101V11ZM36.6108 1.2H31.8088V11H34.6368V8.004H36.5968C38.4168 8.004 40.1108 6.828 40.1108 4.602C40.1108 2.264 38.4588 1.2 36.6108 1.2ZM36.0508 5.68H34.6368V3.58H36.0928C36.8068 3.58 37.2548 3.902 37.2548 4.602C37.2548 5.33 36.7928 5.68 36.0508 5.68ZM47.6843 11H50.5403V3.86H53.1443V1.2H45.0803V3.86H47.6843V11ZM59.2334 11.238C62.2014 11.238 64.4134 9.054 64.4134 6.1C64.4134 3.146 62.2014 0.962 59.2334 0.962C56.2654 0.962 54.0534 3.146 54.0534 6.1C54.0534 9.054 56.2654 11.238 59.2334 11.238ZM59.2334 8.508C57.9874 8.508 56.9934 7.514 56.9934 6.1C56.9934 4.686 57.9874 3.692 59.2334 3.692C60.4794 3.692 61.4734 4.686 61.4734 6.1C61.4734 7.514 60.4794 8.508 59.2334 8.508Z"
                        fill="#FEFCF9"
                      />
                    </svg>
                  </Popover.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="fixed right-2 z-10 mt-4 w-[78vw] max-w-sm transform px-4 sm:px-0 md:absolute md:w-screen lg:max-w-lg">
                      <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="relative grid gap-8 bg-white p-7 lg:grid-cols-2">
                          {solutions.map((item) => (
                            <button
                              onClick={(e) => goTo(item.route)}
                              key={item.name}
                              className="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                            >
                              <div className="relative flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12">
                                <div className="absolute left-0 top-0 z-10 h-[62px] w-[62px]" />
                                <div className="relative z-20 flex h-full w-full items-center justify-center">
                                  <item.icon aria-hidden="true" />
                                </div>
                              </div>
                              <div className="ml-4">
                                <p className="text-md font-medium text-gray-900">
                                  {item.name}
                                </p>
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </li>
          <li>
            <button
              onClick={goToFooter}
              className="nav-item mr-[0.8vmax] block cursor-pointer"
            >
              <span className="hidden">Discord</span>
              <div className="flex h-[2.7vmax] w-[2.7vmax] items-center justify-center rounded-full border-[0.16vmax] border-white">
                <svg
                  className="w-[1.5vmax]"
                  viewBox="0 0 22 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6305 1.24555C17.1782 0.658363 15.6663 0.231317 14.0946 0C13.8957 0.320285 13.6769 0.729537 13.5177 1.06762C11.8466 0.836299 10.1556 0.836299 8.48448 1.06762C8.30543 0.69395 8.10649 0.338078 7.88765 0C6.31601 0.231317 4.78415 0.658363 3.35177 1.26335C0.487006 5.08897 -0.288869 8.80783 0.0891213 12.4911C1.78013 13.6121 3.65018 14.4662 5.6595 15C6.11707 14.4484 6.51495 13.879 6.85315 13.274C6.19664 13.0605 5.57992 12.7936 4.9831 12.4733C5.14225 12.3665 5.28151 12.2598 5.44067 12.153C8.96194 13.6477 13.0601 13.6477 16.5814 12.153C16.7406 12.2598 16.8798 12.3665 17.039 12.4733C16.4422 12.7936 15.8055 13.0605 15.149 13.274C15.4872 13.879 15.8851 14.4484 16.3427 15C18.352 14.4484 20.242 13.6121 21.9131 12.4911C22.3507 8.22064 21.1173 4.51957 18.6305 1.24555ZM7.33061 10.2135C6.23643 10.2135 5.36109 9.32384 5.36109 8.23843C5.36109 7.15302 6.23643 6.24555 7.33061 6.24555C8.44469 6.24555 9.32003 7.13523 9.32003 8.23843C9.30014 9.32384 8.44469 10.2135 7.33061 10.2135ZM14.6517 10.2135C13.5575 10.2135 12.6822 9.32384 12.6822 8.23843C12.6822 7.15302 13.5575 6.24555 14.6517 6.24555C15.7658 6.24555 16.6411 7.13523 16.6212 8.23843C16.6013 9.34164 15.7459 10.2135 14.6517 10.2135Z"
                    fill="#FCFAF7"
                  />
                </svg>
              </div>
            </button>
          </li>
          <li>
            <a
              href="https://twitter.com/magicfolk_nft"
              target="_blank"
              className="nav-item mr-[0.8vmax] block"
            >
              <span className="hidden">Twitter</span>
              <div className="flex h-[2.7vmax] w-[2.7vmax] items-center justify-center rounded-full border-[0.16vmax] border-white">
                {iconTwitter}
              </div>
            </a>
          </li>
          <li className="nav-item mr-[1.6vmax] block">
            <div className="relative flex h-[2.7vmax] w-[2.7vmax] items-center justify-center rounded-full border-[0.16vmax] border-white">
              <div
                onClick={() => toggleAudio(theme)}
                id="audio-toggle"
                className="absolute left-1/2 top-1/2 w-[76%] -translate-y-1/2 -translate-x-1/2 transform"
              />
            </div>
            <div className="hidden">
              <audio 
                id="audio-dark" 
                onLoadedData={() => setAudioLoadedCount(globalState.audioLoadedCount + 1)}
                onError={(e) => { console.log(e) }}
              >
                <source src="/m-dark.mp3" type="audio/mpeg" />
              </audio>
              <audio 
                id="audio-light"
                onLoadedData={() => setAudioLoadedCount(globalState.audioLoadedCount + 1)}
                onError={(e) => { console.log(e) }}
              >
                <source src="/m-light.mp3" type="audio/mpeg" />
              </audio>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default Header

function iMarketplace() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="62" height="62" rx="31" fill="#F4AA53" />
      <path
        d="M45 35.5C45 43.5081 38.2843 50 30 50C21.7157 50 15 43.5081 15 35.5C15 27.4919 21.7157 21 30 21C31.5474 21 33.0401 21.2265 34.4444 21.6471C35 23.1481 34.6473 24.1481 36.1111 25.2963C37.2791 26.2124 40.1611 24.0848 41 25.2963C43.2222 27.9815 45 32.5192 45 35.5Z"
        fill="white"
      />
      <path
        d="M36.5 15.5C36.5 15.5 34.5 21.0001 33.5 23.0001L39 26.5001L44.5 20.5L36.5 15.5Z"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M31.1592 37.7749C34.1592 38.7749 34.1592 40.3256 34.1592 40.3256C35.3391 45.0519 32.6472 41.6231 34.5045 42.0919C36.0782 42.489 36.714 42.3597 37.2888 42.1541C37.9198 41.9283 38.5277 42.6594 38.1296 43.1501C38.0232 43.2818 37.9836 43.3324 37.9668 43.3538C37.9576 43.3655 37.9553 43.3684 37.9527 43.3711L37.9514 43.3724L37.9497 43.374L37.9454 43.3781C33.8434 47.3979 27.0278 47.8555 22.2592 44.0718C17.1359 40.0067 16.1321 32.6606 20.0952 27.7545C20.6143 27.1118 21.3143 26.4508 21.9376 25.9542C22.023 25.8862 22.1053 25.8244 22.1845 25.7687C23.0378 25.079 23.9571 24.8696 24.7211 25.3528C25.9949 26.1587 26.0834 26.809 26.3645 28.8757L26.3654 28.8828L26.3663 28.8893C26.3663 28.8893 26.3688 26.0092 26.3667 28.8921C26.3645 31.7749 28.1592 36.7749 31.1592 37.7749Z"
        fill="#CF6240"
      />
      <path
        d="M33.8136 35.9691L30.9602 37.1816C26.4083 39.0904 23.0381 37.7196 21.5 36.5C20.1969 35.4666 19.5 34.5 18.9645 33.7452C18.4291 32.9903 17.7831 33.0484 17.6355 33.668C17.5957 33.8339 17.5796 33.8967 17.5728 33.9232C17.5691 33.9378 17.5682 33.9414 17.5676 33.9452L17.5674 33.9469L17.5672 33.9493L17.5665 33.9553C16.8829 39.7122 20.769 45.5074 26.8006 47.0752C33.2808 48.7597 39.8374 45.1208 41.3233 38.9392C41.5179 38.1294 41.6144 37.1622 41.6262 36.3567C41.6277 36.2463 41.6262 36.1422 41.6217 36.0444C41.6456 34.9356 41.2407 34.0644 40.3737 33.7387C38.9278 33.1957 38.3476 33.5182 36.5039 34.5429L36.4975 34.5465L36.4918 34.5497L36.4893 34.5511C35.806 34.9307 34.95 35.4063 33.8136 35.9691Z"
        fill="#F4AA53"
      />
      <path
        d="M45.7126 19.253C45.3733 19.8142 44.6484 20.2239 43.5334 20.2619C42.4294 20.2995 41.0747 19.9548 39.7667 19.164C38.4587 18.3733 37.524 17.3339 37.0443 16.3388C36.5598 15.3339 36.5857 14.5016 36.925 13.9404C37.2643 13.3793 37.9892 12.9696 39.1042 12.9316C40.2082 12.8939 41.5629 13.2387 42.8709 14.0294C44.1789 14.8202 45.1136 15.8595 45.5933 16.8546C46.0778 17.8595 46.0518 18.6919 45.7126 19.253Z"
        fill="#F4AA53"
        stroke="white"
        stroke-width="2"
      />
    </svg>
  )
}

function iEquip() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="62" height="62" rx="31" fill="#F4AA53" />
      <path
        d="M31 48.1178C32.045 48.117 33.0714 47.8411 33.976 47.3178L44.024 41.5151C44.9306 40.9955 45.6835 40.2451 46.2062 39.3402C46.7289 38.4353 47.0028 37.4082 47 36.3631V24.7365C46.9997 23.7124 46.7351 22.7058 46.232 21.8138C45.7101 20.8883 44.947 20.1215 44.024 19.5952L33.976 13.7925C33.0701 13.2732 32.0441 13 31 13C29.9558 13 28.9299 13.2732 28.024 13.7925L23.16 16.6085L17.976 19.6058C17.053 20.1322 16.2899 20.8989 15.768 21.8245C15.2666 22.7133 15.0021 23.716 15 24.7365L15 36.3631C15.0002 37.4245 15.2838 38.4666 15.8213 39.3818C16.3415 40.2611 17.0753 40.9949 17.9547 41.5151L28.0027 47.3178C28.8932 47.8282 29.899 48.1035 30.9253 48.1178H31ZM29.0907 15.6485C29.6712 15.3133 30.3297 15.1369 31 15.1369C31.6703 15.1369 32.3288 15.3133 32.9093 15.6485L42.9573 21.4512C43.2315 21.6128 43.4857 21.8061 43.7146 22.0272L38.7013 24.9285L25.8267 17.5258L29.0907 15.6485ZM23.6933 18.7632L36.568 26.1552L31.0427 29.3552L18.2427 22.0272C18.471 21.8053 18.7252 21.6119 19 21.4512L23.6933 18.7632ZM19.0427 39.6698C18.472 39.3388 17.9976 38.8645 17.6667 38.2938C17.3148 37.7115 17.1303 37.0435 17.1333 36.3631V24.7365C17.1373 24.4455 17.173 24.1557 17.24 23.8725L29.9333 31.1365V45.8138C29.656 45.7267 29.3881 45.6124 29.1333 45.4725L19.0427 39.6698ZM44.8666 36.3631C44.8675 37.0207 44.6984 37.6674 44.376 38.2405C44.0412 38.8366 43.5509 39.3306 42.9573 39.6698L32.8987 45.4831C32.6235 45.6377 32.3295 45.756 32.024 45.8351V31.2432L39.2346 27.0832L44.76 23.8832C44.8262 24.1629 44.8619 24.449 44.8666 24.7365V36.3631Z"
        fill="black"
      />
      <path
        d="M45.4002 23.1362L30.4668 30.6029L28.3335 45.5362L33.1335 46.6029L45.4002 39.6696L45.9335 34.3362L45.4002 23.1362Z"
        fill="#CF6240"
      />
      <path
        d="M31 48.1178C32.045 48.117 33.0714 47.8411 33.976 47.3178L44.024 41.5151C44.9306 40.9955 45.6835 40.2451 46.2062 39.3402C46.7289 38.4353 47.0028 37.4082 47 36.3631V24.7365C46.9997 23.7124 46.7351 22.7058 46.232 21.8138C45.7101 20.8883 44.947 20.1215 44.024 19.5952L33.976 13.7925C33.0701 13.2732 32.0441 13 31 13C29.9558 13 28.9299 13.2732 28.024 13.7925L23.16 16.6085L17.976 19.6058C17.053 20.1322 16.2899 20.8989 15.768 21.8245C15.2666 22.7133 15.0021 23.716 15 24.7365L15 36.3631C15.0002 37.4245 15.2838 38.4666 15.8213 39.3818C16.3415 40.2611 17.0753 40.9949 17.9547 41.5151L28.0027 47.3178C28.8932 47.8282 29.899 48.1035 30.9253 48.1178H31ZM29.0907 15.6485C29.6712 15.3133 30.3297 15.1369 31 15.1369C31.6703 15.1369 32.3288 15.3133 32.9093 15.6485L42.9573 21.4512C43.2315 21.6128 43.4857 21.8061 43.7146 22.0272L38.7013 24.9285L25.8267 17.5258L29.0907 15.6485ZM23.6933 18.7632L36.568 26.1552L31.0427 29.3552L18.2427 22.0272C18.471 21.8053 18.7252 21.6119 19 21.4512L23.6933 18.7632ZM44.8666 36.3631C44.8675 37.0207 44.6984 37.6674 44.376 38.2405C44.0412 38.8366 43.5509 39.3306 42.9573 39.6698L32.8987 45.4831C32.6235 45.6377 32.3295 45.756 32.024 45.8351V31.2432L39.2346 27.0832L44.76 23.8832C44.8262 24.1629 44.8619 24.449 44.8666 24.7365V36.3631Z"
        fill="white"
      />
    </svg>
  )
}

function iQuestMap() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="62" height="62" rx="31" fill="#F4AA53" />
      <path d="M11 22H16V14C13.2386 14 11 16.2386 11 19V22Z" fill="#CF6240" />
      <path d="M21 20H16V14H21V20Z" fill="white" />
      <path d="M21 22H16V14C18.7614 14 21 16.2386 21 19V22Z" fill="#CF6240" />
      <path
        d="M21 14H40C42.7614 14 45 16.2386 45 19V50H27C23.6863 50 21 47.3137 21 44V14Z"
        fill="white"
      />
      <path
        d="M27 49V42L51 42V44.375C51 47.0433 49.1017 49 47 49H27Z"
        fill="#F4AA53"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M22 42H27L26 49C23.2386 49 22 47.0412 22 44.625V42Z"
        fill="white"
      />
      <path d="M32 42H27L26 49C30.5 49 32 46 32 43V42Z" fill="white" />
      <path
        d="M29.2426 28.364C28.6569 27.7782 28.6569 26.8285 29.2426 26.2427C29.8284 25.6569 30.7782 25.6569 31.364 26.2427L37.7279 32.6067C38.3137 33.1925 38.3137 34.1422 37.7279 34.728C37.1421 35.3138 36.1924 35.3138 35.6066 34.728L29.2426 28.364Z"
        fill="#CF6240"
      />
      <path
        d="M35.6066 26.2427C36.1924 25.6569 37.1421 25.6569 37.7279 26.2427C38.3137 26.8285 38.3137 27.7782 37.7279 28.364L31.364 34.728C30.7782 35.3138 29.8284 35.3138 29.2426 34.728C28.6569 34.1422 28.6569 33.1925 29.2426 32.6067L35.6066 26.2427Z"
        fill="#CF6240"
      />
    </svg>
  )
}

function iTeam() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3775_5373)">
        <rect width="62" height="62" rx="31" fill="#F4AA53" />
        <circle
          cx="31"
          cy="28"
          r="10"
          fill="#CF6240"
          stroke="white"
          stroke-width="2"
        />
        <circle
          cx="31"
          cy="57"
          r="19"
          fill="#F4AA53"
          stroke="white"
          stroke-width="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3775_5373">
          <rect width="62" height="62" rx="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function iFaqs() {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="62" height="62" rx="31" fill="#F4AA53" />
      <path
        d="M26.874 44C26.874 42.5221 27.2639 41.494 28.0436 40.9157C28.8233 40.3052 29.7746 40 30.8974 40C31.989 40 32.9247 40.3052 33.7044 40.9157C34.4842 41.494 34.874 42.5221 34.874 44C34.874 45.4137 34.4842 46.4418 33.7044 47.0843C32.9247 47.6948 31.989 48 30.8974 48C29.7746 48 28.8233 47.6948 28.0436 47.0843C27.2639 46.4418 26.874 45.4137 26.874 44Z"
        fill="#CF6240"
      />
      <path
        d="M27.544 33.942C27.544 33.018 27.67 32.192 27.922 31.464C28.174 30.736 28.58 30.05 29.14 29.406C29.728 28.762 30.498 28.104 31.45 27.432C32.29 26.816 32.962 26.27 33.466 25.794C33.998 25.318 34.376 24.842 34.6 24.366C34.852 23.89 34.978 23.358 34.978 22.77C34.978 21.874 34.642 21.202 33.97 20.754C33.326 20.278 32.416 20.04 31.24 20.04C30.064 20.04 28.902 20.222 27.754 20.586C26.606 20.95 25.43 21.44 24.226 22.056L22 17.562C23.372 16.806 24.856 16.19 26.452 15.714C28.048 15.238 29.798 15 31.702 15C34.614 15 36.868 15.7 38.464 17.1C40.088 18.5 40.9 20.278 40.9 22.434C40.9 23.582 40.718 24.576 40.354 25.416C39.99 26.256 39.444 27.04 38.716 27.768C37.988 28.468 37.078 29.224 35.986 30.036C35.174 30.624 34.544 31.128 34.096 31.548C33.648 31.968 33.34 32.374 33.172 32.766C33.032 33.158 32.962 33.648 32.962 34.236V35.454H27.544V33.942Z"
        fill="white"
      />
    </svg>
  )
}

function iLogo() {
  return (
    <svg
      viewBox="0 0 192 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="header--logo w-full"
    >
      <path
        d="M61.0927 17.0987L63.7512 18.3865L64.9959 30.3351L64.9605 30.4114L64.7908 30.6949C64.7283 30.8029 64.6433 30.9335 64.5448 31.0822C64.4298 31.2387 64.3066 31.3895 64.1757 31.534C64.0315 31.6968 63.8826 31.8598 63.7247 32.0273C63.5607 32.199 63.3767 32.3517 63.1763 32.4823C62.9672 32.6196 62.758 32.748 62.5439 32.8632C62.3178 32.9883 62.0772 33.0868 61.8271 33.1565C61.5611 33.2182 61.2874 33.2426 61.0143 33.229C60.3721 33.2223 59.7499 33.0131 59.2421 32.6331C58.6461 32.199 58.1402 31.6598 57.751 31.0439C57.2739 30.3007 56.8717 29.5148 56.5499 28.6971C56.1771 27.7726 55.8637 26.8267 55.6114 25.8648C55.3545 24.8811 55.1295 23.8746 54.949 22.7871C54.7685 21.6997 54.6259 20.6694 54.5299 19.6784C54.4354 18.6858 54.3799 17.7312 54.3635 16.8144C54.2272 13.8942 54.509 10.9692 55.2009 8.12284C55.8626 5.69809 56.8883 4.24917 58.278 3.77607C58.7114 3.5506 59.2177 3.49527 59.6918 3.62159C60.1411 3.73127 60.5817 3.87214 61.0101 4.0431C61.4611 4.24529 61.8675 4.52971 62.2071 4.88082C62.6145 5.28307 62.9707 5.65507 63.2712 5.99692C63.6105 6.38942 63.9135 6.81002 64.1768 7.25387C64.4847 7.7514 64.7358 8.16091 64.9256 8.48249C65.1153 8.80406 65.301 9.15687 65.4781 9.541C65.6551 9.92512 65.7701 10.1768 65.8135 10.2918C65.8616 10.4067 65.8999 10.4906 65.9284 10.5435L67.0467 3.92139L65.6864 5.00533L65.1762 4.51144C64.7098 4.07724 64.1718 3.72131 63.5844 3.45823C62.8083 3.0885 61.9994 2.78715 61.1674 2.55783C60.0942 2.3031 58.9737 2.29728 57.897 2.54086C56.5167 2.81385 55.2014 3.33583 54.0199 4.07955C52.2269 5.27156 50.745 6.85138 49.692 8.69361C48.4061 10.7516 47.6438 13.0755 47.4681 15.4735C47.2889 17.003 47.2811 18.5465 47.445 20.0771C47.5965 21.5976 47.8665 23.1048 48.2526 24.5856C48.6309 26.006 49.2322 27.3615 50.0357 28.6048C50.8076 29.8234 51.8207 30.8824 53.0167 31.7209C54.1611 32.5449 55.4291 33.1947 56.7767 33.6478C57.8892 34.0355 59.0594 34.246 60.2419 34.2712C61.2924 34.2637 62.3378 34.1267 63.3529 33.8637C64.251 33.6401 65.1225 33.3261 65.9531 32.9266C66.6506 32.5759 67.3184 32.1724 67.9505 31.72L68.0685 31.6355C68.6497 31.22 69.0522 30.9323 69.2303 30.7621C69.4202 30.5806 69.5788 30.4487 69.6831 30.3667L69.1992 19.2949L71.2663 17.3613L61.0927 17.0987Z"
        fill="#1D1926"
      />
      <path
        d="M24.3948 4.78106L26.331 30.3975L29.4119 31.9048L18.3164 32.8074L20.5245 31.2986L19.1933 8.38244L13.102 30.822L4.24078 10.106L5.70563 32.5702L8.1696 34.0396L1.30458 34.1316L3.88851 32.8031L2.44109 7.97922L0.0516793 6.30817L8.65099 6.1538L14.1021 20.9478L18.6476 4.11852L26.3784 3.32088L24.3948 4.78106Z"
        fill="#1D1926"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.3721 7.13418L47.2917 34.6016L50.0162 36.4937L41.0085 36.8735L42.4915 35.449L39.9701 27.9663L33.6516 28.5249L31.5492 37.9737L33.8138 39.6114L26.7954 39.8709L29.6802 37.1125L36.3721 7.13418ZM33.9702 27.059L39.5124 26.55L36.241 16.7391L33.9702 27.059Z"
        fill="#1D1926"
      />
      <path
        d="M77.9661 9.35244L79.0961 32.5883L81.3232 34.1866L70.4496 34.6444L73.6833 32.3605L72.1628 10.4316L69.3305 8.93763L81.1133 7.88918L77.9661 9.35244Z"
        fill="#1D1926"
      />
      <path
        d="M94.8154 30.4862C94.1993 30.4654 93.5879 30.3748 92.9938 30.2162C91.8595 29.8833 90.932 28.8583 90.2113 27.1409C89.4489 25.2272 89.0194 23.2042 88.9402 21.1538C88.8135 18.8819 88.8479 16.604 89.0432 14.3363C89.1774 12.3304 89.6065 10.353 90.3175 8.46377C90.9749 6.82261 91.7617 5.90033 92.6779 5.69691C93.4403 5.55636 94.2277 5.62233 94.9533 5.88756C95.6336 6.12057 96.2636 6.47295 96.8117 6.92707C97.3364 7.38586 97.8082 7.89832 98.2189 8.45549C98.5378 8.85535 98.8238 9.27892 99.0741 9.72226C99.1664 9.92016 99.2728 10.1116 99.3925 10.2953L100.34 4.6423L98.7495 5.73037L98.1447 5.34502C97.6192 5.05914 97.059 4.83743 96.4771 4.68493C95.6708 4.45824 94.8484 4.2885 94.0166 4.17707C92.9548 4.06702 91.8808 4.15429 90.8523 4.4342C89.5923 4.75463 88.4 5.28685 87.3299 6.00659C85.5115 7.19373 84.1646 9.02682 83.2893 11.5059C81.6079 16.3358 81.915 21.6052 84.1467 26.217C85.2356 28.4619 86.6552 29.9946 88.4053 30.8149C89.7385 31.4241 91.158 31.8382 92.6173 32.0437C93.8202 32.2348 95.0441 32.2712 96.2572 32.152C97.2536 32.0267 98.2364 31.8154 99.194 31.5205C99.842 31.3369 100.477 31.1128 101.095 30.8498C101.339 30.7358 101.574 30.6036 101.796 30.4544L100.796 25.9404C100.781 25.9697 100.765 26.0083 100.748 26.0518C100.733 26.0882 100.717 26.1283 100.699 26.1692C100.681 26.2083 100.657 26.2652 100.626 26.3389C100.586 26.4344 100.534 26.5581 100.469 26.7075C100.357 26.964 100.228 27.2131 100.082 27.4534C99.9026 27.7443 99.7049 28.0244 99.4902 28.2921C99.2501 28.5993 98.9812 28.8843 98.6868 29.1435C98.3647 29.4082 98.016 29.6412 97.6461 29.8388C97.24 30.0535 96.8092 30.2211 96.3627 30.3382C95.8568 30.4593 95.3357 30.5091 94.8154 30.4862Z"
        fill="#1D1926"
      />
      <path
        d="M111.608 9.49539L109.05 8.65096L128.596 6.55499L128.805 12.8283L125.991 8.26671L117.473 8.99836L118.684 22.4299L124.529 22.1558L125.737 20.2599L125.74 25.5575L124.82 23.4995L118.807 23.6342L120.013 37.0258L122.895 37.9623L111.831 39.3273L114.545 36.7722L111.608 9.49539Z"
        fill="#1D1926"
      />
      <path
        d="M167.714 28.2381L166.676 31.6401L159.686 32.1974L159.871 8.68866L162.197 7.03537L150.849 7.23906L153.385 8.37326L154.261 31.5069L152.548 33.1892L168.258 32.9072L167.714 28.2381Z"
        fill="#1D1926"
      />
      <path
        d="M179.15 17.0318L188.418 32.9809L191.665 34.5342L181.332 36.8966L182.958 34.7083L176.323 20.2255L175.169 21.5061L175.682 34.1889L178.309 35.7934L168.62 36.6351L170.438 35.4227L169.495 8.76133L168.051 7.45172L175.682 7.23906L174.04 8.56399L175.095 18.9521L184.019 6.69318L183.259 5.09528L190.532 6.28635L187.058 7.23906L179.15 17.0318Z"
        fill="#1D1926"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.277 10.8609C142.311 10.4008 141.248 10.1811 140.087 10.2019C138.753 10.2259 137.554 10.5143 136.49 11.067C135.455 11.6193 134.612 12.3366 133.961 13.219C133.308 14.0734 132.761 15.1084 132.319 16.3241C131.876 17.5399 131.564 18.7392 131.382 19.9222C131.2 21.1051 131.092 22.371 131.059 23.7199C131.017 24.6194 131.048 25.5317 131.151 26.4568C131.254 27.3537 131.416 28.2497 131.635 29.1446C131.883 30.0389 132.188 30.8901 132.551 31.6982C132.914 32.5062 133.362 33.2425 133.897 33.907C134.431 34.5715 135.022 35.1508 135.669 35.6447C136.316 36.1106 137.062 36.4624 137.908 36.7C138.753 36.9095 139.639 36.9779 140.567 36.905C141.871 36.7974 143.024 36.3975 144.027 35.7054C145.06 35.0127 145.871 34.1696 146.463 33.1759C147.083 32.1536 147.585 30.9929 147.967 29.694C148.35 28.367 148.603 27.0985 148.726 25.8885C148.878 24.6499 148.942 23.3848 148.919 22.0932C148.898 20.9138 148.761 19.7507 148.508 18.6036C148.285 17.456 147.931 16.3669 147.449 15.3363C146.995 14.3052 146.428 13.4166 145.747 12.6704C145.065 11.8962 144.242 11.293 143.277 10.8609ZM143.555 19.1138C143.727 20.5713 143.811 22.0304 143.808 23.491C143.778 25.0645 143.703 26.5264 143.582 27.8768C143.461 29.2272 143.267 30.5368 143 31.8055C142.761 33.0457 142.387 34.0355 141.878 34.7749C141.369 35.5143 140.752 35.8906 140.026 35.9036C139.243 35.9176 138.551 35.3683 137.951 34.2556C137.351 33.1428 136.905 31.7745 136.615 30.1506C136.353 28.4981 136.205 26.7312 136.172 24.8499C136.134 22.7721 136.186 20.819 136.328 18.9908C136.497 17.1339 136.859 15.4281 137.411 13.8733C137.963 12.2905 138.687 11.4208 139.584 11.2643C140.279 11.1675 140.908 11.4793 141.473 12.1994C142.036 12.8915 142.474 13.8527 142.787 15.0829C143.128 16.3127 143.384 17.6563 143.555 19.1138Z"
        fill="#1D1926"
      />
    </svg>
  )
}
